import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiDummyButton } from 'noddi-ui-web';
import { useEffect, useRef, useState } from 'react';

export const CopyReferralLink = ({ referralCode }: { referralCode: string }) => {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const referralLink = `${window.location.host}/referrals/${referralCode}`;

  useEffect(
    () => () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    },
    []
  );

  const copyToClipboard = () => {
    // oxlint-disable-next-line typescript/no-floating-promises -- best-effort copy; a browser-denied clipboard write is not surfaced (the copied state still flips)
    navigator.clipboard.writeText(referralLink);
    setIsCopied(true);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => setIsCopied(false), 3000);
  };

  return (
    <NoddiBasicCard onClick={copyToClipboard} variant='secondary' className='flex flex-col gap-4'>
      <p className='text-xl font-semibold text-primary'>
        {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
        <Trans>My referral link</Trans> 🎉
      </p>

      <div className='flex flex-col items-end gap-2'>
        <div className='w-full rounded-lg border border-primary px-3 py-1.5'>
          <p className='max-w-52 truncate xxs:max-w-none'>{referralLink}</p>
        </div>
        <NoddiDummyButton variant='outline' startIcon={isCopied ? 'Check' : 'SquareArrowOutUpRight'} size='small'>
          {isCopied ? <Trans>Copied!</Trans> : <Trans>Copy referral link</Trans>}
        </NoddiDummyButton>
      </div>
    </NoddiBasicCard>
  );
};
